/* eslint-disable no-unused-vars */
import React, {useEffect} from 'react';

import PropTypes from 'prop-types';

import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useDispatch, useSelector } from 'react-redux';

import { Layout } from 'antd';

import LogoType from '../../assets/lt_full_logo.png';
import { ReactComponent as LogoDark } from '../../assets/life-logo-dark.svg';
import { ReactComponent as Logout } from '../../assets/logout-icon.svg';

import { logOut } from '../../data/store/user/userActions';

import './style.scss';

const { Sider } = Layout;

const OnboardingSideBar = ({
  userId,
  setUserId,
  needSave,
  theme,
  children,
}) => {
  const { t } = useTranslation('');
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { role, first_name, last_name } = useSelector(
    (state) => state.userReducer.advisor,
  );

  const getUserName = () => {
    const roleUser = role === 'SUPERADMIN' ? t('ADMIN') : t('ADVISOR');
    const nameUser =
      first_name || last_name ? `${first_name} ${last_name}` : '';
    return { roleUser, nameUser };
  };
  // const users = useSelector((state) => state.accountReducer.accounts?.list);

  const handleLogout = () => {
    dispatch(logOut());
  };

  return (
    <Sider
      id="advisers"
      width="450"
      className="sider-style"
      collapsible
      collapsed={false}
      trigger={null}
    >
      <div className="client-wrapper onboarding">
        <div className='onboarding-content'>
          <NavLink to={'/'} className="logotype">
            {theme === 'dark-theme' ? (
              <LogoDark />
            ) : (
              <img src={LogoType} alt="" />
            )}
          </NavLink>
          {children}
        </div>
        <div className="client-bottom-box">
            <div className="client-box-text-wraper">
              <p className="client-text-name">{getUserName().nameUser}</p>
              <p className="client-text-role">{getUserName().roleUser}</p>
            </div>
          <div className="client-logout-link" onClick={handleLogout}>
            <Logout />
          </div>
        </div>
      </div>
    </Sider>
  );
};

export default OnboardingSideBar;

OnboardingSideBar.propTypes = {
  userId: PropTypes.number,
  setUserId: PropTypes.func,
  needSave: PropTypes.bool,
  theme: PropTypes.string,
  children: PropTypes.node,
};
